import React, { useState } from 'react';
import { Shield, MessageCircle } from 'lucide-react';
import RegistrationModal from './RegistrationModal';

const StatsSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('registration');

  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  return (
    <>
      <RegistrationModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialType={modalType}
      />
      <div className="py-16 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left: CTA Content */}
            <div>
              <h2 className="text-4xl md:text-6xl font-bold leading-tight">
                Your Brand Deserves Legal Protection
              </h2>
              <p className="text-xl md:text-2xl text-gray-300 mt-6">
                File your trademark in minutes with expert attorneys. Fast, affordable, guaranteed.
              </p>
            </div>

            {/* Right: CTA Buttons */}
            <div className="flex flex-col gap-4">
              <button
                onClick={() => openModal('registration')}
                className="group w-full flex items-center justify-center bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] hover:from-[#FF8C42] hover:to-[#FF6B35] text-white font-bold px-8 py-5 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#FF6B35]/30"
              >
                <Shield className="w-5 h-5 mr-2" />
                Start Registration
                <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </button>
              
              <button
                onClick={() => {
                  if (window.cd360Api && window.cd360Api.liveChat) {
                    window.cd360Api.liveChat.showWebWidget();
                  } else {
                    console.log('Chat widget not loaded yet');
                  }
                }}
                className="group w-full flex items-center justify-center border-2 border-white/30 hover:border-white text-white font-semibold px-8 py-5 rounded-lg transition-all duration-300 hover:bg-white/10"
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                Discuss with Attorney
                <span className="ml-2 text-green-400">●</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsSection;